import { Slot } from '@radix-ui/react-slot';

import { mergeClasses } from '@/utils';

import { BADGE_VARIANTS } from './Badge.constants';
import { IBadge } from './Badge.interfaces';

const Badge = ({ className, variant, asChild = false, ...props }: IBadge) => {
  const Component = asChild ? Slot : 'span';

  return (
    <Component
      data-slot="badge"
      className={mergeClasses(BADGE_VARIANTS({ variant }), className)}
      {...props}
    />
  );
};

export default Badge;
